import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { eur, useSettings } from "@/lib/api";

export const KlarnaMessage = ({ price }) => {
  const k = useSettings()?.klarna;
  if (!k?.enabled || price < (k.min || 0) || (k.max && price > k.max)) return null;
  return (
    <p className="mt-3 rounded-xl bg-[#FFB3C7]/25 px-4 py-3 text-sm text-slate-800" data-testid="klarna-message">
      <b>Paga anche in 3 rate con Klarna.</b> 3 rate da circa {eur(price / 3)} (importo indicativo). Soggetto ad approvazione di Klarna.
    </p>
  );
};

export const CloudFreeNotice = ({ p }) =>
  /cloud free/i.test(`${p.category_path} ${p.name}`) ? (
    <div className="mt-6 flex gap-3 rounded-2xl border border-[#0066FF]/30 bg-[#0066FF]/5 p-4 text-sm text-slate-700" data-testid="cloud-free-notice">
      <Info className="h-5 w-5 shrink-0 text-[#0066FF]" />
      <p><b>Dispositivo CLOUD FREE</b> (dispositivo senza espansione). Prima dell'acquisto leggi i dettagli nella <Link to="/pagina/cloud-free" className="text-[#0066FF] underline">pagina dedicata</Link>. Diritto di recesso e garanzia legale restano validi quando previsti.</p>
    </div>
  ) : null;
